import { Component } from '@angular/core';

@Component({
  selector: '[hd-left-menu-item]',
  templateUrl: './main-toolbar-menu-item.component.html',
  styleUrls: ['./main-toolbar-menu-item.component.scss']
})
export class MainToolbarMenuItemComponent {}
